module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"WishListIcon":{"notifications":{"loginFirst":"Musíte se nejdříve přihlásit","error":"Něco se porouchalo","success":"Produkt byl přidán do oblíbených"}}},"en":{}}')
  delete Component.options._Ctor
}
